const createMembershipPackageToast = (state = null, action) => {
  if (action.type === "SET_CREATE_MEMBERSHIP_PACKAGE_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_CREATE_MEMBERSHIP_PACKAGE_TOAST": {
  //     return action.payload;
  //   }
  //   default: {
  //     return state;
  //   }
  // }
};

export default createMembershipPackageToast;
